"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterOptions = getFilterOptions;
exports.filterOptionsWatcher = filterOptionsWatcher;

var _effects = require("redux-saga/effects");

var _apiRequest = require("../api/apiRequest");

var _selectors = require("../../filters/value/selectors");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var _actions2 = require("../../filters/options/actions");

var _Utils = _interopRequireDefault(require("../../../utils/Utils"));

var _selectors2 = require("../../filters/forms/selectors");

var _lodash = _interopRequireDefault(require("lodash"));

var _component = require("../../../constants/component");

var _selectors3 = require("../../locale/selectors");

var _filters = require("../../../constants/filters");

var _AbortError = require("../../../common/errors/AbortError");

var _selectors4 = require("./selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getFilterOptions),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadFilterOptions),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(filterOptionsWatcher);

function getFilterOptions(filterType, fieldName, optionsSource, abortController) {
  var url, dataMapping, state, requestParams, relatedFilterForms, rawOptions, options;
  return regeneratorRuntime.wrap(function getFilterOptions$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

          if (optionsSource) {
            _context.next = 3;
            break;
          }

          throw new Error("Filter options source is not set!");

        case 3:
          url = optionsSource.url;
          dataMapping = optionsSource.mapping || _Utils["default"].mapOptions;

          if (url) {
            _context.next = 7;
            break;
          }

          throw new Error("Wrong filter options source url `" + url + "`!");

        case 7:
          _context.next = 9;
          return (0, _effects.put)(actions.request(filterType, fieldName));

        case 9:
          _context.next = 11;
          return (0, _effects.select)();

        case 11:
          state = _context.sent;
          // Prepare request params ...
          requestParams = {
            locale: (0, _selectors3.getLocale)(state)
          };

          if (filterType === _filters.FILTER_TYPE.SALES_DASHBOARD) {
            requestParams.salesReportType = optionsSource.salesReportType;
          }

          relatedFilterForms = (0, _selectors2.getFilterFormByFilterType)(state, filterType);

          _lodash["default"].forEach(relatedFilterForms, function (filterForm) {
            _lodash["default"].merge(requestParams, (0, _selectors.getValue)(state, filterForm[_component.PROPS.FILTER_TYPE]));

            _lodash["default"].forEach(filterForm[_component.PROPS.RELATED_FILTERS], function (filterType) {
              _lodash["default"].merge(requestParams, (0, _selectors.getValue)(state, filterType));
            });
          });

          if (url === _filters.FILTER_URLS.SALES_BRAND_RELATED_URL) {
            requestParams.brandId = [];
          }

          _context.next = 19;
          return (0, _effects.call)(_apiRequest.apiRequest, url, "POST", {
            body: requestParams,
            locale: (0, _selectors3.getLocale)(state)
          }, abortController ? abortController.signal : undefined);

        case 19:
          rawOptions = _context.sent;
          options = dataMapping(rawOptions);
          _context.next = 23;
          return (0, _effects.put)(actions.success(filterType, fieldName));

        case 23:
          _context.next = 25;
          return (0, _effects.put)(actions.increment(filterType, fieldName, (0, _selectors4.getIsDisabled)(state, filterType, fieldName)));

        case 25:
          return _context.abrupt("return", options);

        case 28:
          _context.prev = 28;
          _context.t0 = _context["catch"](0);

          if (_context.t0 instanceof _AbortError.AbortError) {
            _context.next = 34;
            break;
          }

          console.error(_context.t0);
          _context.next = 34;
          return (0, _effects.put)(actions.failure(filterType, fieldName));

        case 34:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 28]]);
}

function loadFilterOptions(action) {
  var _action$payload, filterType, fieldName, optionsSource, abortController, options;

  return regeneratorRuntime.wrap(function loadFilterOptions$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, filterType = _action$payload.filterType, fieldName = _action$payload.fieldName, optionsSource = _action$payload.optionsSource, abortController = _action$payload.abortController;
          _context2.next = 3;
          return (0, _effects.call)(getFilterOptions, filterType, fieldName, optionsSource, abortController);

        case 3:
          options = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)((0, _actions2.setOptions)(filterType, fieldName, options));

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function filterOptionsWatcher() {
  return regeneratorRuntime.wrap(function filterOptionsWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, loadFilterOptions);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}